import { IResponse } from "@app/common/types/http";
import { HTTP_DISPENSARY } from "@app/config/axios";
import { clearEmptyKeys } from "@app/common/utils/utils";
import {
  AnnulDeliveryRequest,
  CancellationDeliveriesFilter,
  PatchAnnulDeliveryPayload
} from "./types";

export async function getAnnulDeliveryRequestsService(
  filters: CancellationDeliveriesFilter,
  token: string
) {
  const res = await HTTP_DISPENSARY(token).get<IResponse<AnnulDeliveryRequest[]>>(
    "/request-annul-delivery/",
    { params: clearEmptyKeys(filters) }
  );
  return res.data;
}

export async function patchAnnulDeliveryRequestService(
  radId: number,
  payload: PatchAnnulDeliveryPayload,
  token: string
) {
  const res = await HTTP_DISPENSARY(token).patch<IResponse<null>>(
    `/request-annul-delivery/${radId}`,
    payload
  );
  return res.data;
}
